import React from 'react';
import PropTypes from 'prop-types';

export default function Broadcast({ broadcasts }) {
    return broadcasts
        .filter(broadcast => !!broadcast.title && !!broadcast.message)
        .map(broadcast => (
            <section className="broadcast u-mb16" data-testid="broadcast" key={broadcast.title}>
                <div className="broadcast__content">
                    <h2 className="u-screen-reader-only">{broadcast.title}</h2>
                    <span dangerouslySetInnerHTML={{ __html: broadcast.message }} />
                </div>
            </section>
        ));
}

Broadcast.propTypes = {
    broadcasts: PropTypes.array.isRequired,
};
